<!-- self-service-datastore-form.component.html -->
<!-- 
<app-modal-title
  [title]="
    (this.data.onlyPreview
      ? 'DataStoreFormPage.DataPreview'
      : 'DataStorePage.AddNewData'
    ) | translate
  "
></app-modal-title>
<mat-dialog-content style="overflow: hidden !important">
  <div
    *ngIf="this.data.onlyPreview"
    style="
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    "
  >
    <ag-grid-angular
      style="height: 100%; width: 100%"
      class="ag-theme-alpine"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [rowData]="rowData"
      [rowSelection]="'multiple'"
      [animateRows]="true"
      (gridReady)="onGridReady($event)"
      (cellClicked)="onCellClicked($event)"
    ></ag-grid-angular>
  </div>
 
</mat-dialog-content> -->
<!-- 
<div
  class="button_group"
  style="margin-right: 5%"
  *ngIf="!this.data.onlyPreview"
>
  <button class="b-btn" mat-dialog-close>
    {{ "DataStoreFormPage.Cancel" | translate }}
  </button>
  <button
    class="b-btn b-success"
    (click)="backStep()"
    *ngIf="stepper?.selectedIndex !== 0"
  >
    {{ "DataStoreFormPage.Back" | translate }}
  </button>
  <button
    class="b-btn b-success"
    (click)="nextStep()"
    *ngIf="stepper?.selectedIndex !== stepper?.steps?.length - 1"
  >
    {{ "DataStoreFormPage.Next" | translate }}
  </button>
  <button
    mat-button
    class="b-btn b-success"
    cdkFocusInitial
    *ngIf="stepper?.selectedIndex === stepper?.steps?.length - 1"
    (click)="saveDataStoreFile()"
  >
    {{ "Common.Save" | translate }}
  </button>
</div>

<div class="loading-overlay" *ngIf="showLoading">
  <div class="loading-spinner"></div>
</div> -->
<app-custom-modal
  [title]="
    (this.data.onlyPreview
      ? 'DataStoreFormPage.DataPreview'
      : 'DataStorePage.AddNewData'
    ) | translate
  "
  [subtitle]="'SelfServicePage.MainDescription'"
  img="/assets/images/widgetSelection.png"
>
  <div class="modal-body" body>
    <div class="file-upload-container">
      <div class="file-upload-area">
        <div class="file-upload-content" (click)="fileInput.click()">
          <img src="/assets/images/upload.svg" class="upload-icon" />
          <div>{{ "DataStoreFormPage.SelectFile" | translate }}</div>
          <input
            type="file"
            [accept]="fileAccept"
            (change)="onFileChange($event)"
            #fileInput
            style="visibility: hidden;height: 0px;"
          />
        </div>
        <div class="file-types">
          <div *ngFor="let item of acceptFileTypes">
            <img
              [src]="item.img"
              class="file-type-icon"
              (click)="openFileSelect(item.type, item.index)"
            />
          </div>
        </div>
        <div class="fileName">{{fileName}}</div>
      </div>

      <form class="data-store-form" [formGroup]="dataStoreForm">
        <div class="ds-form-row">
          <mat-form-field>
            <mat-label>{{ "DataStoreFormPage.Name" | translate }}</mat-label>
            <input matInput type="text" formControlName="FileName" required />
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ "DataStoreFormPage.Append" | translate }}</mat-label>
            <mat-select formControlName="append" required>
              <mat-option value="0">{{
                "DataStoreFormPage.AddNewData" | translate
              }}</mat-option>
              <mat-option value="1">{{
                "DataStoreFormPage.Overwrite" | translate
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <mat-form-field *ngIf="this.data.type == 'update'">
          <mat-label>{{ "DataStoreFormPage.DsApiKey" | translate }}</mat-label>
          <input matInput type="text" formControlName="ApiKey" readonly />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{
            "DataStoreFormPage.Description" | translate
          }}</mat-label>
          <textarea matInput formControlName="Description" rows="3"></textarea>
        </mat-form-field>
      </form>
    </div>

    <div class="table-container">
      <app-ag-grid-table
        *ngIf="rowData.length > 0"
        [rowData]="rowData"
        [typeSelect]="true"
        [columnTypes]="columnTypes"
        (menuEvent)="changeType($event)"
      ></app-ag-grid-table>
      <div
        *ngIf="rowData.length <= 0"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
        "
      >
        <table class="tg">
          <tr *ngFor="let item of skeletonRows;let i = index">
            <!-- <th class="tg-cly1" *ngFor="let col of skeletonCols" *ngIf="i===0">
              <div class="line"></div>
            </th> -->
            <td class="tg-cly1" *ngFor="let col of skeletonCols">
              <div class="line"></div>
            </td>
          </tr>
        </table>
        <div class="tg-text">{{"DataStoreFormPage.DisplayData" | translate}}</div>
      </div>
    </div>

    <div class="button-group">
      <button
        mat-stroked-button
        class="custom-primary-stroked-button"
        mat-dialog-close
      >
        {{ "Common.Cancel" | translate }}
      </button>
      <button
        mat-stroked-button
        class="custom-primary-button"
        (click)="saveDataStoreFile()"
      >
        {{ "Common.Save" | translate }}
      </button>
    </div>
  </div>
</app-custom-modal>
